import { TransactionalSaleFormTabId, TransactionalSaleFormTabs } from "./index";

export const MobileTransactionalCreateSaleModalTabOrder: TransactionalSaleFormTabId[] =
  [
    TransactionalSaleFormTabs.WHO,
    TransactionalSaleFormTabs.WHAT,
    TransactionalSaleFormTabs.WHEN,
    TransactionalSaleFormTabs.PRICE,
    TransactionalSaleFormTabs.REVIEW,
  ];
